module.exports = __webpack_public_path__ + "static/media/dyalog.640f3787.svg";